import React from "react"
import Animate, { AnimationTypes } from "../Animate/Animate"

interface BasicCardProps {
  title?: string
  borderColor?: string
  bgColor?: string
  txtColor?: string
  width?: string
  blink?: boolean
}

export const BasicCard: React.FC<BasicCardProps> = ({
  title,
  borderColor = "#fb923c",
  bgColor = "white",
  txtColor = "#1f2937",
  width = "auto",
  blink = false,
}) => {
  return (
    <div
      className={`
        inline-flex
        items-center
        justify-center
        rounded-full
        px-3 py-[2px]
        text-[0.75rem]
        font-bold
        border-2
        transition-all duration-300
        ${blink ? "animate-pulse" : ""}
      `}
      style={{
        color: txtColor,
        borderColor: borderColor,
        backgroundColor: bgColor,
        width,
      }}
    >
      {title}
    </div>
  )
}
